/* Copyright (c) 2021 MOCA Systems, Inc.  All rights reserved. */

//remove the above when we have a proper library solution
export class LinkMap<T = string, Idx1 = string, Idx2 = string> {
	public get isEmpty(): boolean {
		return this._internalMap.size === 0;
	}

	private _internalMap: Map<Idx1, Map<Idx2, T>> = new Map();

	/** combine a bunch of link maps, takes any number of them, right most takes priority. Returns the result */
	public static merge<T = string, Idx1 = string, Idx2 = string>(
		...maps: Array<LinkMap<T, Idx1, Idx2>>
	): LinkMap<T, Idx1, Idx2> {
		const targetMap = new LinkMap<T, Idx1, Idx2>();
		maps.forEach((link) => {
			link.forEachy((key1, key2, data) => {
				targetMap.set(key1 as Idx1, key2 as Idx2, data);
			});
		});
		return targetMap;
	}
	public has(string1: Idx1, string2: Idx2): boolean {
		return !!(this._internalMap.has(string1) && this._internalMap.get(string1)?.has(string2));
	}
	public get(string1: Idx1, string2: Idx2): T | undefined {
		return this._internalMap.has(string1) ? this._internalMap.get(string1)?.get(string2) : undefined;
	}
	public set(string1: Idx1, string2: Idx2, optionalData?: T): void {
		let subMap;
		const data = optionalData !== undefined ? optionalData : string2;
		if (!this._internalMap.has(string1)) {
			subMap = new Map();
			this._internalMap.set(string1, subMap);
		} else {
			subMap = this._internalMap.get(string1);
		}
		//don't check if the value already exists, let the code using this class use has first, leave this dumb
		subMap?.set(string2, data);
	}
	public delete(string1: Idx1, string2: Idx2): boolean {
		if (!this._internalMap.has(string1)) {
			return false;
		}
		return !!this._internalMap.get(string1)?.delete(string2);
	}
	/** delete everything an id is pointing at. Make this option explicit */
	public deleteAll(string1: Idx1): boolean {
		if (!this._internalMap.has(string1)) {
			return false;
		}
		return this._internalMap.delete(string1);
	}

	// public forEachy(cb: (key1: Idx2, key2: Idx1, optionalData?:T)=>void, reverse?: true)
	// public forEachy(cb: (key1: Idx1, key2: Idx2, optionalData?:T)=>void, reverse?: false)
	public forEachy(
		cb: (key1: Idx1 | Idx2, key2: Idx2 | Idx1, optionalData?: T) => void,
		reverse: boolean = false
	): void {
		this._internalMap.forEach((subMap, mainKey) => {
			subMap.forEach((sub, subKey) => {
				if (reverse) {
					cb(subKey, mainKey, sub);
				} else {
					cb(mainKey, subKey, sub);
				}
			});
		});
	}
}
